<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
  },
}
</script>

<style>
@import url("~@/style/app.css");
</style>
